import PropTypes from 'prop-types';
import React from 'react';
import { bindAll } from '@bibliocommons/utils-react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { setFocusWithinElement } from '@bibliocommons/utils-accessibility';
import { ugcQuotationShape, catalogBibShape, userIdentityShape, childrenShape } from '@bibliocommons/bc-prop-types';
import TextUgcDisplayContainer from 'app/components/bibs/shared/ugc/TextUgcDisplay';
import { QuotationEditorContainer } from 'app/components/bibs/shared/ugc/QuotationEditor';
import DeleteQuotationModalContainer from 'app/components/bibs/shared/ugc/DeleteQuotationModal';

export default class QuotationDisplay extends React.PureComponent {
  optionsDropdownRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = { editorIsOpen: false };
    bindAll(this);
  }

  componentDidUpdate(prevProps, prevState) {
    // Set focus on the options dropdown when the editor is closed.
    if (!this.state.editorIsOpen && prevState.editorIsOpen && this.optionsDropdownRef.current) {
      setFocusWithinElement(this.optionsDropdownRef.current);
    }
  }

  toggleEditor(value) {
    this.setState({ editorIsOpen: value });
  }

  openDeletionModal() {
    const quotationId = this.props.quotation.get('id');
    this.props.modalActions.openModal(`delete-quotation-${quotationId}`);
  }

  renderEditor() {
    const { catalogBib, quotation } = this.props;
    return (
      <QuotationEditorContainer
        catalogBib={catalogBib}
        quotationId={quotation.get('id')}
        handleCancel={() => this.toggleEditor(false)}
        handleSuccess={() => this.toggleEditor(false)}
      />
    );
  }

  render() {
    if (this.state.editorIsOpen) return <div className="cp-quotation-display">{this.renderEditor()}</div>;

    const { quotation, displayStaffBadge, users, catalogBib, children, handleDeleteSuccess } = this.props;
    const author = users.get(quotation.get('userId').toString());
    const quotationId = quotation.get('id');
    return (
      <div className="cp-quotation-display">
        <TextUgcDisplayContainer
          ugcType="quotation"
          catalogBib={catalogBib}
          author={author}
          id={quotationId}
          key={quotationId}
          createdDate={quotation.get('createdDate')}
          displayStaffBadge={displayStaffBadge}
          compact
          optionsDropdownRef={this.optionsDropdownRef}
          handleDelete={this.openDeletionModal}
          handleEdit={() => this.toggleEditor(true)}
        >
          {children}
        </TextUgcDisplayContainer>

        <DeleteQuotationModalContainer
          quotationId={quotationId}
          catalogBib={catalogBib}
          handleSuccess={handleDeleteSuccess}
          handleFocusOnRestore={this.handleDeleteFocus}
        />
      </div>
    );
  }
}

QuotationDisplay.defaultProps = {
  displayStaffBadge: true
};

QuotationDisplay.propTypes = {
  quotation: ugcQuotationShape.isRequired,
  catalogBib: catalogBibShape.isRequired,
  handleDeleteSuccess: PropTypes.func,
  users: ImmutablePropTypes.mapOf(userIdentityShape).isRequired,
  displayStaffBadge: PropTypes.bool,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  children: childrenShape.isRequired
};
